import { render, staticRenderFns } from "./phlangu.vue?vue&type=template&id=a1242ca4"
import script from "./phlangu.vue?vue&type=script&lang=js"
export * from "./phlangu.vue?vue&type=script&lang=js"
import style0 from "./phlangu.vue?vue&type=style&index=0&id=a1242ca4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports